import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FoodCake24Regular } from '@fluentui/react-icons';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ValidatedCollapseCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { FormCardBody, FormCardSummary } from '@bingads-webui-fluent-component/form-cards';

import { formatAgeRanges, TargetingAge } from '../components/targeting-age';
import { AudiencesSkeleton } from '../components/skeletons';

export const CollapsibleAge = ({ ageRanges, isLoading, ...cardProps }) => {
  const i18n = useContext(I18nContext);
  return (
    <ValidatedCollapseCard {...cardProps}>
      <FormCardBasicHeader
        title={i18n.getString(_TL_('Age'))}
        // TODO: Age help topic is pending
        // helpTopic="pop_BA_Settings_LocationTargeting"
        contentBefore={<FoodCake24Regular />}
      />
      <FormCardBody>
        {!isLoading
          ? <TargetingAge ageRanges={ageRanges} />
          : <AudiencesSkeleton />}
      </FormCardBody>
      <FormCardSummary>
        {!isLoading
          ? formatAgeRanges(ageRanges, i18n)
          : <AudiencesSkeleton />}
      </FormCardSummary>
    </ValidatedCollapseCard>
  );
};

CollapsibleAge.propTypes = {
  ageRanges: PropTypes.arrayOf(PropTypes.string).isRequired,
  isLoading: PropTypes.bool.isRequired,
};
